import {
  Button,
  Typography,
  IconButton,
  InputAdornment,
  TextField,
  Box,
  Grid,
  Dialog,
  Select,
  MenuItem,
  Radio,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { style } from "@mui/system";
import useStyles from "./styles";
import OtpInput from "react-otp-input";
import { LoggerClass as Logger } from "utils/logger";

type Props = {};
const DownloadAllDialog = ({
  showPopup,
  closePopup = () => {},
  handleClose = () => {},
  handleSelect,
}) => {
 
  const styles = useStyles();
  const [show, setShow] = useState(false);
  const [otp, setOtp] = useState("");
  const [disable, setDisable] = useState(true);
  const [selectedCheck, setSelectedCheck] = useState<any>([]);

  const close = () => {
    setShow(false);
    closePopup();
  };

  useEffect(() => {
    if (otp?.length === 4) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [otp?.length]);

  useEffect(() => {
    setSelectedCheck([]);
    setShow(showPopup);
  }, [showPopup]);

  return (
    <Dialog open={show} className={styles.popup}>
      <Box sx={{ display: "flex", flexDirection: "column", margin: "16px" }}>
        <div
          style={{
            fontFamily: "Open Sans",
            fontSize: 18,
            color: "#192342",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          Download Successful transaction receipts
          
        </div>

        <div
          style={{
            fontFamily: "Open Sans",
            fontSize: 16,
            color: "#192342",
            fontWeight: "400",
            textAlign: "center",
            marginTop: 10
          }}
        >
          Select the year for which you want to download successful transaction receipts:
          
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 25,
          }}
        >
          <Button
            className={styles.signInButton}
            onClick={() => {
              handleSelect(selectedCheck);
            }}
            style={{ marginLeft: 0 }}
            
          >
            Select
          </Button>

          <Button
            className={styles.outlinebtn}
            onClick={close}
            variant="outlined"
          >
            Cancel
          </Button>
        </div>
      </Box>
    </Dialog>
  );
};

export default DownloadAllDialog;
